import React from "react";
import { Modal, Button, Spinner } from "react-bootstrap";

const ConfirmationDialog = ({ show, onHide, onConfirm, selectedAction, selectedEmail, availableNumbers, selectedNumber, setSelectedNumber, loading }) => {
  // Generate Custom Message Based on Selected Action
  const getActionTitle = () => {
    if (!selectedAction) return "";
    
    return selectedAction
      .replace(/([A-Z])/g, " $1")
      .trim()
      .replace(/^./, (str) => str.toUpperCase());
  };

  return (
    <Modal show={show} onHide={onHide} centered className="modal-lg">
      <Modal.Header closeButton className="border-0 pb-0">
        <Modal.Title className="d-flex align-items-center">
          <div className="bg-warning bg-opacity-10 p-2 rounded-circle me-3">
            <span role="img" aria-label="warning" className="text-warning fs-4">
              ⚠️
            </span>
          </div>
          <span className="fw-bold">Confirmation</span>
        </Modal.Title>
      </Modal.Header>
      
      <Modal.Body className="pt-2 pb-4">
        {selectedAction === "purchaseNumber" ? (
          <div className="text-center mb-4">
            <h5 className="mb-3">Are you sure you want to {getActionTitle()} for</h5>
            <div className="bg-light py-2 px-3 d-inline-block rounded mb-3">
              <span className="fw-bold text-primary">{selectedEmail}</span>
            </div>
            {/* Modified: Put alert on its own line with proper width */}
            <div className="w-100"></div>
            <div className="alert alert-warning d-inline-block py-2 px-4 mt-2">
              <span className="d-flex align-items-center">
                <i className="bi bi-credit-card me-2"></i>
                A monthly fee of <span className="fw-bold mx-1">$1.15</span> will be applied.
              </span>
            </div>
            
            <div className="mt-4">
              <label htmlFor="phoneNumber" className="form-label fw-bold mb-2">
                Select a phone number:
              </label>
              <div className="position-relative">
                {loading[selectedEmail] ? (
                  <div className="d-flex justify-content-center align-items-center py-2">
                    <Spinner animation="border" variant="primary" size="sm" role="status" className="me-2" />
                    <span>Loading available numbers...</span>
                  </div>
                ) : (
                  <select
                    id="phoneNumber"
                    className="form-select form-select-lg shadow-sm border-0 bg-light py-3"
                    value={selectedNumber}
                    onChange={(e) => setSelectedNumber(e.target.value)}
                  >
                    <option value="">Select a number</option>
                    {availableNumbers.map((number) => (
                      <option key={number} value={number}>
                        {number}
                      </option>
                    ))}
                  </select>
                )}
              </div>
            </div>
          </div>
        ) : (
          <div className="text-center my-4 py-2">
            <h5 className="mb-3">Are you sure you want to {getActionTitle()} for</h5>
            <div className="bg-light py-2 px-4 d-inline-block rounded">
              <span className="fw-bold text-primary">{selectedEmail}</span>
            </div>
            
            {selectedAction === "deleteUser" && (
              /* Modified: Changed the alert to be centered with controlled width */
              <div className="d-flex justify-content-center mt-3">
                <div className="alert alert-danger d-inline-block" style={{ maxWidth: "80%" }}>
                  <i className="bi bi-exclamation-triangle-fill me-2"></i>
                  This action cannot be undone.
                </div>
              </div>
            )}
          </div>
        )}
      </Modal.Body>
        
      <Modal.Footer className="border-0 pt-0">
        <div className="d-flex gap-2 w-100 justify-content-center">
          <Button 
            variant="primary" 
            onClick={onConfirm} 
            disabled={selectedAction === "purchaseNumber" && !selectedNumber}
            className="px-4 py-2"
          >
            Yes, proceed
          </Button>
          <Button 
            variant="outline-secondary" 
            onClick={onHide}
            className="px-4 py-2"
          >
            Cancel
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default ConfirmationDialog;